<template>
  <div>
    <Header />
    <slot />
  </div>
</template>

<script setup>
import Header from "@/components/Header.vue";
</script>
